import { apiClient } from "../config";

async function useFormAsTemplate(id: string , data:any) {
  const res = await apiClient.post(`/admin/dynamic-forms/${id}/template`, data);
  return res.data;
}

export default useFormAsTemplate;
